import React, { forwardRef, useImperativeHandle, useMemo, useRef, useState } from "react";
import { RCCChartComposedChart, RCCGrid, RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import {  IGraphicData, IRefModalGraphic } from "../interface";

const ModalGraphic: React.ForwardRefRenderFunction<IRefModalGraphic> = (_, ref) => {

	const { translate } = useTranslation();
	const { addToast } = RCCHookToast();

	const [subtitleModal, setSubtitleModal] = useState("");
	const [graphicData, setGraphicData] = useState<IGraphicData | null>(null);
	const modalAddOrChange = useRef<RCCRefModalProps>(null);

	const openModalGraphic = async (mab001Id: number, baseYear: number, mab004Descricao: string) => {	
		setSubtitleModal(mab004Descricao);
		queryDataGraphic(mab001Id,baseYear);
	};

	const queryDataGraphic = async (mab001Id: number, baseYear: number) => {
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: "MarketShare/SelectDataForGraphic",
				urlParameters: {
					mab001Id,
					baseYear
				}
			});
			if(!data.dataSource || data.dataSource?.length <= 0){
				addToast({
					color: "yellow",
					description: translate("Insira algum valor para poder visualizar no grafico"),
					title: translate("Atenção")
				});
				return;
			}
			setGraphicData(data);
			modalAddOrChange.current?.openModal();
		}catch(err){
			standardErrorMessages(err, `${translate("Erro ao carregar dados")}`, addToast);
		}
	};


	const dataModal = (faturamento?: boolean) => {
		if(!graphicData)
			return null; 

		const onlyUnique = (value: number, index: number, self: number[]) => self.indexOf(value) === index;
		const years = graphicData.dataSource.map((e) => e.year).filter(onlyUnique).sort((a, b) => a - b);
	
		const dataToReturn: any = [];
		years.forEach((ye) => {
			const yearData = graphicData.dataSource.filter((e) => e.year === ye);
			const criteria: any = [];
			criteria.name = `${translate("Ano")} ${ye}`;
			yearData.forEach((comparative : IGraphicData["dataSource"][0]) => {
				criteria[`${comparative.dataKey}`] = faturamento ? comparative.faturamento : comparative.marketshare;
			});	
			dataToReturn.push({
				...criteria
			});
		});
		return dataToReturn;
	};

	useImperativeHandle(ref, () => ({
		openModalGraphic
	}));

	const ComposedChartFaturamento  = useMemo(() => (
		<RCCChartComposedChart 
			width={500}
			height={400}
			data={dataModal(true)}
			xAxis={{}}
			yAxis={[{}]}
			bar={graphicData?.series.map((e) => ({
				dataKey: e.dataKey,
				name: e.name,
				barSize: 64,
				label: { position: "center", angle: 90 }
			}))}
		/>
	), [graphicData]);

	const ComposedChartMarketShare  = useMemo(() => (
		<RCCChartComposedChart 
			width={500}
			height={400}
			data={dataModal(false)}
			xAxis={{}}
			yAxis={[{}]}
			bar={graphicData?.series.map((e) => ({
				dataKey: e.dataKey,
				name: e.name,
				barSize: 64,
				label: { position: "center", angle: 90 }
			}))}
		/>
	), [graphicData]);
    
	return (
		<>		
			<Modal
				ref={modalAddOrChange}
				header={{
					title: `${translate("Gráfico de Análise")}` ,
					subtitle: `${translate("Análise")}: ${subtitleModal}`,
					icon: {
						name: "chartBar"
					}
				}}
				footer= {{
					showSaveButton: false,
					cancelButtonText: translate("Fechar")
				}}
				withoutForm
			>
				<RCCGrid
					container
					item
					justifyContent="center"
					style={{ marginTop: "1rem" }}
				>
					<Title size="lg" color="purple">
						{translate("Faturamento")}
					</Title>
				</RCCGrid>
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					style={{ height: "400px"}}
				>
					{ComposedChartFaturamento}
				</RCCGrid>
				<RCCGrid
					container
					item
					justifyContent="center"
					style={{ marginTop: "2rem" }}
				>
					<Title size="lg" color="purple">
						{translate("Market Share")}
					</Title>
				</RCCGrid>
				<RCCGrid
					container
					item
					direction="column"
					alignItems="center"
					style={{ height: "400px"}}
				>
					{ComposedChartMarketShare}
				</RCCGrid>
			</Modal>
		</>
	);
};

export default forwardRef(ModalGraphic);
